function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.81.4a.6.6 0 110 1.2H1.488a.6.6 0 010-1.2h11.32z",
  fill: "#333"
});

function SvgIconMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 2,
    viewBox: "0 0 14 2",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMiIgdmlld0JveD0iMCAwIDE0IDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIuODA5NCAwLjM5OTkwMkMxMy4xNDA4IDAuMzk5OTAyIDEzLjQwOTQgMC42Njg1MzEgMTMuNDA5NCAwLjk5OTkwM0MxMy40MDk0IDEuMzMxMjcgMTMuMTQwOCAxLjU5OTkgMTIuODA5NCAxLjU5OTlDNS40NzIyOCAxLjU5OTkgOC40NDA3MSAxLjU5OTkgMS40ODg2NyAxLjU5OTlDMS4xNTczIDEuNTk5OSAwLjg4ODY3MiAxLjMzMTI3IDAuODg4NjcyIDAuOTk5OTAzQzAuODg4NjcyIDAuNjY4NTMxIDEuMTU3MyAwLjM5OTkwMiAxLjQ4ODY3IDAuMzk5OTAyQzguNDQwNzEgMC4zOTk5MDIgNS40NzIyOSAwLjM5OTkwMiAxMi44MDk0IDAuMzk5OTAyWiIgZmlsbD0iIzMzMzMzMyIvPgo8L3N2Zz4K";
export { SvgIconMinus as ReactComponent };